import React from 'react'

const EventPaidClents = () => {
    return (
        <div>

        </div>
    )
}

export default EventPaidClents
